import { useEffect, useRef } from 'react';

const NAME = 'nichecom-pechakucha';

export function openChannel() {
  if (typeof BroadcastChannel === 'undefined') return null;
  return new BroadcastChannel(NAME);
}

// Stage side: broadcast state, receive commands from the presenter window.
export function usePresenterBroadcast(state, handlers) {
  const ch = useRef(null);
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;
  useEffect(() => {
    ch.current = openChannel();
    if (!ch.current) return undefined;
    ch.current.onmessage = (e) => {
      const { cmd, arg } = e.data || {};
      const fn = handlersRef.current?.[cmd];
      if (fn) fn(arg);
    };
    return () => ch.current?.close();
  }, []);
  useEffect(() => {
    ch.current?.postMessage({ type: 'state', state });
  }, [state]);
}
